import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useLang } from "@/context/LangContext";
import { Card } from "@/components/ui/card";
import { StatusBadge } from "@/components/StatusBadge";
import { MapPin } from "lucide-react";

export default function SitesPage() {
  const { t } = useLang();
  const [sites, setSites] = useState([]);
  useEffect(() => { api.get("/sites").then((r) => setSites(r.data)); }, []);

  return (
    <div className="space-y-6" data-testid="sites-page">
      <div>
        <div className="text-[10px] font-mono uppercase tracking-[0.3em] text-white/40">
          {t("sites")}
        </div>
        <h1 className="text-3xl font-semibold tracking-tight mt-1">Sites DNDi</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {sites.map((s) => (
          <Card key={s._id} className="bg-white/[0.02] border-white/10 rounded-sm p-4"
                data-testid={`site-${s.name}`}>
            <div className="flex items-start justify-between">
              <MapPin className="h-5 w-5 text-cyan-400" />
              <StatusBadge status={s.active ? "trusted" : "warning"}>
                {s.active ? "actif" : "inactif"}
              </StatusBadge>
            </div>
            <div className="mt-2 text-lg font-semibold tracking-tight">{s.name}</div>
            <div className="mt-1 text-xs font-mono text-white/50">
              {s.country} · {s.lat.toFixed(2)}, {s.lon.toFixed(2)}
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
